import HTTP from 'http';
import URL from 'url';
import path from 'path';
import { HOST, ROOT_URL } from '../../config';

const BACKEND_URL = HOST + ROOT_URL;

export default function upload(reqURL, objectData) {
  const url = BACKEND_URL + reqURL;
  const formData = new FormData();
  if (objectData) {
    Object.keys(objectData).forEach(attrName => {
      let value = objectData[attrName];
      if (value instanceof File) {
        formData.append(attrName, value);
      } else {
        value = value && typeof value === 'object' ? JSON.stringify(value) : value;
        formData.append(attrName, value);
      }
    });
  }
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    const localData = localStorage.getItem('currentUser') || '{}';
    const jwt = JSON.parse(localData).jwt;
    if (jwt) {
      xhr.setRequestHeader('Authorization', `Bearer ${jwt}`);
    }
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        try {
          const response = JSON.parse(xhr.response);
          return resolve(response);
        } catch (e) {
          const response = xhr.response;
          return resolve(response);
        }
      }
    };
    xhr.onerror = (error) => {
      return reject(error);
    };
    xhr.send(formData);
  });
}



// WEBPACK FOOTER //
// ./src/frontend/helpers/upload.js